import { useEffect, useState } from "react";
import API from "../api";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const Home = () => {
  const [fires, setFires] = useState([]);

  useEffect(() => {
    fetchFires();
  }, []);

  const fetchFires = async () => {
    try {
      const response = await API.get("/fires");
      console.log("Fire Data:", response.data); // debugging
      setFires(response.data || []);
    } catch (error) {
      console.error("Error fetching fires:", error);
      setFires([]);
    }
  };

  const validFires = fires.filter((fire) => {
    const lat = parseFloat(fire.latitude);
    const lng = parseFloat(fire.longitude);
    return !isNaN(lat) && !isNaN(lng);
  });

  const highRiskCount = validFires.filter(
    (fire) => fire.fire_risk_percentage > 70
  ).length;

  const defaultCenter = [20.5937, 78.9629]; // India center

  return (
    <div className="dashboard">
      <h1>Real-Time Incident Dashboard</h1>
      <div className="divider"></div>

      {/* STATS CARDS (UI SAME AS BEFORE) */}
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Incidents</h3>
          <p>{validFires.length}</p>
        </div>

        <div className="stat-card">
          <h3>High Risk Cases</h3>
          <p>{highRiskCount}</p>
        </div>

        <div className="stat-card">
          <h3>Backend Status</h3>
          <p style={{ color: "#22c55e" }}>LIVE</p>
        </div>
      </div>

      {/* MAP SECTION (UI SAME) */}
      <div className="map-container">
        <MapContainer
          center={defaultCenter}
          zoom={5}
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            attribution="© OpenStreetMap contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {validFires.map((fire, index) => {
            const lat = parseFloat(fire.latitude);
            const lng = parseFloat(fire.longitude);

            return (
              <Marker
                key={index}
                position={[lat, lng]}
                icon={L.icon({
                  iconUrl:
                    fire.fire_risk_percentage > 70
                      ? "https://maps.google.com/mapfiles/ms/icons/red-dot.png"
                      : "https://maps.google.com/mapfiles/ms/icons/orange-dot.png",
                  iconSize: [32, 32],
                })}
              >
                <Popup>
                  <strong>Risk:</strong>{" "}
                  {fire.fire_risk_percentage || 0}% <br />
                  <strong>Latitude:</strong> {lat} <br />
                  <strong>Longitude:</strong> {lng}
                  {fire.image && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={`https://firetracker-web-application.onrender.com/uploads/${fire.image}`}
                        alt="Fire"
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  )}
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
    </div>
  );
};

export default Home;


